export enum VisitExitType {
    HD_REFERRAL = 'HD_REFERRAL',
    PHYSICAL_EXAM = 'PHYSICAL_EXAM',
    PUBLIC_HEALTH = 'PUBLIC_HEALTH',
    SELF_HELP = 'SELF_HELP',
    TECHNICAL_ISSUE = 'TECHNICAL_ISSUE',
    UNANSWERED_CALL = 'UNANSWERED_CALL',
    LIFE_STYLE = 'LIFE_STYLE',
}
